<script lang="ts">
	import type { SplittedAddress } from '../../types';
	import ButtonAddToItinerary from '$lib/components/atoms/button/ButtonAddToItinerary.svelte';
	import Link from '$lib/components/atoms/link/Link.svelte';
	import * as m from '$paraglide/messages';
	import PoiSummaryTemplate from '../PoiSummaryTemplate.svelte';

	interface Props {
		name: string;
		address?: SplittedAddress | null;
		bookUrl?: string | null;
		onAddClick?: () => void;
		onBookClick?: () => void;
	}

	const {
		name,
		address = null,
		bookUrl = null,
		onAddClick,
		onBookClick,
	}: Props = $props();

	const color = 'parking';

</script>

<PoiSummaryTemplate {name} {color}>
	{#snippet infos()}
		{#if address !== null}
			<div><span class="truncate">{address.firstLine}</span></div>
			<div class="mb-1"><span class="truncate">{address.secondLine}</span></div>
		{/if}
	{/snippet}
	{#snippet buttons()}
		{#if bookUrl !== null}
			<Link
				button="filled"
				color="primary"
				size="sm"
				icon="shopping-cart"
				label={m.poi_actions__book()}
				href={bookUrl}
				target="_blank"
				rel="external"
				onclick={onBookClick}
			/>
			<ButtonAddToItinerary
				size="sm"
				variant="outline"
				onclick={onAddClick}
			/>
		{:else}
			<ButtonAddToItinerary
				size="sm"
				onclick={onAddClick}
			/>
		{/if}
	{/snippet}
</PoiSummaryTemplate>
